module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.product !== null) ? _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-7"
  }, [_c('product-form', {
    attrs: {
      "product": _vm.product
    },
    on: {
      "saved": _vm.reloadProduct
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-5",
    staticStyle: {
      "border-left": "1px solid #e1e1e1",
      "padding-left": "1.5rem"
    }
  }, [_c('product-parts', {
    attrs: {
      "product-id": _vm.product.id
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('product-items', {
    attrs: {
      "product-id": _vm.product.id
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('product-tags', {
    attrs: {
      "product-id": _vm.product.id
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('product-bundles', {
    attrs: {
      "product-id": _vm.product.id
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('product-categories', {
    attrs: {
      "product-id": _vm.product.id
    }
  })], 1)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75368207"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/src/views/catalog/products/ProductEdit.vue
// module id = 556
// module chunks = 0